import { Chip, ChipType } from '@barkibu/noma-commons';
import { ExternalReview } from '../../../../../../domain/entities/ExternalReview';
import { useModuleTranslation } from '../../../../../../utils/useModuleTranslation';

export type ExternalReviewTagProps = {
    externalReview?: ExternalReview;
};

const ExternalReviewTag = ({ externalReview }: ExternalReviewTagProps) => {
    const { t } = useModuleTranslation();

    if (!externalReview) {
        return null;
    }

    return (
        <span>
            <Chip
                type={ChipType.NEUTRAL}
                text={t('invoice.external_review.tag', { source: externalReview.source })}
                color="blue"
            />
        </span>
    );
};

export default ExternalReviewTag;
